module.exports = __webpack_public_path__ + "img/bell.83a0db40.svg";